import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Mi hijo es demasiado grande/pequeño?',
  a: 'Funciona mejor entre los 2 y 9 años, cuando el sistema sensorial es más plástico.'
}, {
  q: '¿Tengo que comprar algo extra?',
  a: 'No. Tu cuerpo, tu voz y el entorno son tus únicas herramientas.'
}, {
  q: '¿Es un libro largo?',
  a: "No. Es una guía táctica. Menos teoría, más 'haz esto ahora'."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-white px-6" data-id="element-16">
      <div className="max-w-3xl mx-auto" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-19">
            Preguntas frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-20">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-brand-navy/10 rounded-2xl overflow-hidden" data-id="element-21">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left bg-white hover:bg-brand-cream/50 transition-colors" data-id="element-22">
                <span className="font-bold text-lg pr-4" data-id="element-23">{faq.q}</span>
                <ChevronDown className={`shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180 text-brand-sage' : 'text-brand-navy/50'}`} data-id="element-24" />
              </button>
              <AnimatePresence data-id="element-25">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-26">
                    <div className="p-6 pt-0 text-brand-navy/80 leading-relaxed border-t border-brand-navy/5" data-id="element-27">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}